import type { TeamPageNavigation, TeamPerspectiveReport } from "~vue/api/generated/team-perspective/types.gen";

export function withTeamPageLinks(report: TeamPerspectiveReport, navigation: TeamPageNavigation): TeamPerspectiveReport {
    return {
        ...report,
        members: report.members.map((member) => {
            const profileUrl = member.profile_url ?? (member.profile_visible ? navigation.profile_url_template.replace("{user_id}", member.id) : null);
            const memberUrl =
                member.member_url ??
                (member.connection_id
                    ? navigation.connection_url_template.replace("{connection_id}", member.connection_id)
                    : member.id === report.viewer_id
                      ? navigation.self_profile_url
                      : profileUrl);
            return { ...member, profile_url: profileUrl, member_url: memberUrl };
        }),
    };
}
